var prefixedCookies = require('./cookies')('_hcfnl_');

var debug = !!prefixedCookies.get('debug');

module.exports = {
  setEnabled: function(enable) {
    debug = !!enable;
  },
  isEnabled: function() {
    return debug;
  },
  log: function() {
    if (debug) {
      console.log.apply(null, arguments);
    }
  }
}


//////////////////
// WEBPACK FOOTER
// ./lib/debug.js
// module id = 7
// module chunks = 1 3